// components/GlobalAlert.tsx
import React from 'react';
import { useAlert } from '../utils/AlertContext';

const GlobalAlert: React.FC = () => {
  const { alertMessage, alertType, closeAlert } = useAlert();

  if (!alertMessage) return null;

  const baseStyle = "fixed top-20 w-[90vw] mx-auto z-50 rounded-md p-4 shadow-md text-center text-2xl";
  let style = baseStyle;

  switch (alertType) {
    case 'error':
      style += " bg-red-100 text-red-700";
      break;
    case 'success':
      style += " bg-green-100 text-green-700";
      break;
    case 'info':
      style += " bg-blue-100 text-blue-700";
      break;
    case 'warning':
      style += " bg-yellow-100 text-yellow-700";
      break;
    default:
      style += " bg-gray-100 text-gray-700";
  }

  return (
    <div className='flex w-full items-center justify-center'>
        <div className={style} role="alert">
            <span>{alertMessage}</span>
            <button
                onClick={closeAlert}
                className="absolute -top-1 right-0 px-2 text-5xl text-gray-500 hover:text-gray-900 focus:outline-none"
                >
                &times;
            </button>
        </div>
    </div>
  );
};

export default GlobalAlert;
